import { useMemo } from 'react';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { CustomizationFlagQueries } from '@frontend/api-customization-flags';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeStore } from '@frontend/scope';
import { createNavItem, createSubNavItems } from '../nav-item-utils';
import { featureDefinition as reviewsFeatureDefinition } from './feature-definitions';

export const useReviewsNavItem = () => {
  const { t } = useTranslation('primaryNav');
  const { selectedLocationIds } = useAppScopeStore();

  const { isFeatureHiddenInAllLocations: hideReviewsPage } =
    CustomizationFlagQueries.useAggregateCustomizationFlagDetails({
      locationIds: selectedLocationIds,
      enabled: true,
      customizationFlag: Feature.REVIEWS_HOME_ICON,
    });
  const reviewsItems = reviewsFeatureDefinition.items;

  const subNavItems = useMemo(
    () =>
      createSubNavItems([
        {
          ...reviewsItems['/all-reviews'],
          label: t('All Reviews'),
          relativePath: '/all-reviews',
        },
        {
          ...reviewsItems['/google'],
          label: t('Google'),
          relativePath: '/google',
        },
        {
          ...reviewsItems['/facebook'],
          label: t('Facebook'),
          relativePath: '/facebook',
        },
        {
          ...reviewsItems['/private'],
          label: t('Private'),
          relativePath: '/private',
        },
      ]),
    [t, reviewsItems]
  );

  return useMemo(
    () =>
      createNavItem('reviews', {
        iconName: 'reviews-dash',
        label: t('Reviews'),
        root: '/reviews',
        subNavItems,
        settings: { path: '/reviews', label: '', show: true },
        show: !hideReviewsPage,
      }),
    [t, subNavItems, hideReviewsPage]
  );
};
